import React from 'react';
import { cn } from '../../lib/utils';

/**
 * Reusable KPI card. Uses the Kinfolk display font on the numeric value and
 * a small uppercase label above it. `tone` highlights positive/negative
 * deltas (ROI, close-rate) without compromising the monochrome palette.
 */
export function StatTile({ label, value, icon: Icon, format = 'number', tone, testId, hint }) {
  const formatted = (() => {
    if (value == null || value === '') return '—';
    if (format === 'percent') return `${Number(value).toFixed(value % 1 ? 1 : 0)}%`;
    if (format === 'currency') return `$${Number(value).toLocaleString('en-US')}`;
    if (format === 'number') return Number(value).toLocaleString('en-US');
    return String(value);
  })();
  return (
    <div
      data-testid={testId}
      className="rounded-2xl border hairline bg-white px-5 py-4 transition hover:border-neutral-300"
    >
      <div className="flex items-center justify-between">
        <div className="text-[10.5px] uppercase tracking-[0.2em] text-neutral-500 font-bold">{label}</div>
        {Icon && <Icon className="h-3.5 w-3.5 text-neutral-400" />}
      </div>
      <div className={cn(
        'display text-[26px] font-bold tracking-tight mt-2 leading-none',
        tone === 'positive' && 'text-emerald-600',
        tone === 'negative' && 'text-red-600',
        !tone && 'text-neutral-900'
      )}>
        {formatted}
      </div>
      {hint && <div className="text-[11px] text-neutral-400 mt-1.5">{hint}</div>}
    </div>
  );
}

export function SectionHeading({ children }) {
  return (
    <div className="text-[10.5px] uppercase tracking-[0.22em] text-neutral-400 font-bold mb-3">{children}</div>
  );
}

export function EmptyState({ title = 'No data yet', subtitle = 'Upload a CSV from the Upload tab to populate this view.' }) {
  return (
    <div className="rounded-2xl border hairline bg-white p-12 text-center">
      <div className="display text-[18px] font-bold text-neutral-900">{title}</div>
      <div className="text-[12.5px] text-neutral-500 mt-1.5">{subtitle}</div>
    </div>
  );
}
